import React from "react";
import { Grid,useMediaQuery } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./header/Header";
import Footer from "./Footer";
import Layout from "./Layout";
import MobileMenu from "./Nav";
import "../styles/header.scss";

const Home = (props) => {
  const location = useLocation();

  const user = useSelector((state) => state.user);
  const username = user.userProfile.username;
  const isSmall = useMediaQuery('(max-width:768px)');
  const isPortrait = useMediaQuery("(orientation: Landscape)");
  const isMobile = isSmall && isPortrait;
  const access_token = sessionStorage.getItem("access_token");
  const token = access_token ? access_token : "";

  if (location.pathname.includes("login") && username) {
    return <Navigate to="/" state={{ from: location }} replace />;
  } else if (location.pathname.includes("login") && !username) {
    return (
      <React.Fragment>
        <Outlet />
      </React.Fragment>
    );
  } else if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else {
    return (
      <React.Fragment>
        <Grid container> 
          <Grid item xs={12} sm={12}>
            <Grid container>
                  {!isMobile &&
              <Grid
                item
                xs={12}
                sm={1}
                style={{flexBasis:"5%"}}
              >
                <div className="Navigation">
                  <Layout />
                </div>
              </Grid>
  }
                <Header/>
                 {!!isMobile ?<>
              <Grid item xs={12} sm={12}>
                <div className={isMobile ? 'outletContainerMobile' : 'outletContainer'}>
                  <Outlet />
                </div>
              </Grid>
              </> :
               <>
               <Grid item xs={12} sm={11}
                style={{flexBasis:"94%"}}>
                <div className={isMobile ? 'outletContainerMobile' : 'outletContainer'}>
                  <Outlet />
                </div>

              </Grid>
              
              </>}
             {/*  <Footer /> */}
  
          </Grid>
        </Grid>
        </Grid>
      </React.Fragment>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
